import ChallengeTypePhoto from './ChallengeTypePhoto';

export default ChallengeTypePhoto;
